import { g as d } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as o, normalizeClass as r, createElementVNode as e } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconUnlock",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, u = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], h = /* @__PURE__ */ e("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.187 1.887A2 2 0 0 0 4 3.5V5h5.5A1.5 1.5 0 0 1 11 6.5V10a1.5 1.5 0 0 1-1.5 1.5h-7A1.5 1.5 0 0 1 1 10V6.5A1.5 1.5 0 0 1 2.5 5H3V3.5a3 3 0 0 1 5.94-.6.5.5 0 1 1-.98.2 2 2 0 0 0-.773-1.213ZM2 6.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V10a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 2 10V6.5Z",
  "clip-rule": "evenodd"
}, null, -1), f = [
  h
], p = ["id"], m = /* @__PURE__ */ e("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
}, null, -1), g = [
  m
];
function I(a, v, n, b, q, t) {
  return o(), l("svg", {
    "aria-label": n.ariaLabel,
    class: r([t.iconSizeClass, "d-icon d-icon--unlock"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Unlock",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    e("g", {
      "clip-path": `url(#${a.uniqueID}a)`
    }, f, 8, _),
    e("defs", null, [
      e("clipPath", {
        id: `${a.uniqueID}a`
      }, g, 8, p)
    ])
  ], 10, u);
}
const z = /* @__PURE__ */ s(c, [["render", I]]);
export {
  z as default
};
//# sourceMappingURL=unlock.js.map
